import { createSlice } from '@reduxjs/toolkit';

type IUserState = {
  isAuthorized: boolean;
};

const initialState: IUserState = {
  isAuthorized: false,
};

/* istanbul ignore next */
export const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {},
});
